























































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { AgentDto } from '@/shared/dtos/agents-admin';

@Component
export default class AgentsTab extends Vue {
    @Prop() public agents: AgentDto[] = [];
    @Prop() public loading: boolean = false;

    public getStatusClass(status: number): string {
        switch (status) {
            case 2: return 'status-online';
            case 1: return 'status-warning';
            default: return 'status-offline';
        }
    }

    public getStatusColor(status: number): string {
        switch (status) {
            case 2: return 'green';
            case 1: return 'orange';
            default: return 'red';
        }
    }

    public getStatusIcon(status: number): string {
        switch (status) {
            case 2: return 'mdi-server-network';
            case 1: return 'mdi-server-network-outline';
            default: return 'mdi-server-network-off';
        }
    }

    public getStatustext(status: number): string {
        switch (status) {
            case 2: return 'En línea';
            case 1: return 'Advertencia';
            case 0: return 'Sin conexión';
            default: return 'Desconocido';
        }
    }

    public getEnvironmentClass(env: string): string {
        if (env.toLowerCase().includes('prod')) return 'badge-prod';
        if (env.toLowerCase().includes('test')) return 'badge-test';
        if (env.toLowerCase().includes('dev')) return 'badge-dev';
        return 'badge-custom';
    }

    public formatDate(date: Date | null): string {
        if (!date) return 'N/A';
        const d = new Date(date);
        return d.toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    }

    public viewDetails(agent: AgentDto): void {
        this.$emit('view-agent', agent);
    }

    public editAgent(agent: AgentDto): void {
        this.$emit('edit-agent', agent);
    }
}
